<template>
  <v-layout column>
    <v-flex class="pt-5" xs3 offset-xs5>
      <div class="white elevation-2">
        <v-toolbar flat dense color="blue darken-3" dark>
          <v-toolbar-title>Register</v-toolbar-title>
        </v-toolbar>
      </div>
      <div class="elevation-2 pl-4 pr-4 pt-2 pb-2">
        <form
          name="register-form"
          autocomplete="off">
          <v-text-field
            label="Username"
            v-model="username"
            autocomplete="off"
          ></v-text-field>
          <div class="red">{{usernameerror}}</div>
          <br>
          <v-text-field
            label="Password"
            type="password"
            v-model="password"
            autocomplete="new-password"
          ></v-text-field>
          <div class="red">{{passworderror}}</div>
          <br>
          <v-text-field
            label="Email"
            type="email"
            v-model="email"
          ></v-text-field>
          <div class="red">{{emailerror}}</div>
          <br>
          <div>{{inputerror}}</div>
        </form>
        <br>
        <v-btn color="blue darken-3" dark v-on:click="register">Register</v-btn>
    </div>
    </v-flex>
  </v-layout>
</template>

<script>
import AuthenticationService from '@/services/AuthenticationService'

export default {
  data () {
    return {
      username: '',
      usernameerror: '',
      password: '',
      passworderror: '',
      email: '',
      emailerror: '',
      inputerror: null
    }
  },
  methods: {
    async register () {
      try {
        const response = await AuthenticationService.register({
          username: this.username,
          password: this.password,
          email: this.email
        })
        this.$store.dispatch('login', response.data)
        // this.$store.dispatch('setUser', response.data.user)
        this.$router.push('dashboard')
      } catch (error) {
        var errordata = error.response.data
        // this.error = errordata
        this.usernameerror = ''
        this.passworderror = ''
        this.emailerror = ''
        for (var i = 0; i < errordata.length; i++) {
          if (errordata[i].field === 'username') {
            this.usernameerror = errordata[i].message
          }
          if (errordata[i].field === 'password') {
            this.passworderror = errordata[i].message
          }
          if (errordata[i].field === 'email') {
            this.emailerror = errordata[i].message
          }
        }
      }
    }
  }
}
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/homepage/Register.vue